const testimonials = [
  {
    name: "Robert & Linda M.",
    location: "Bonita Springs, FL — Bonita Bay",
    rating: 5,
    text: "We are snowbirds from Grand Rapids, Michigan, and we spend every winter in Bonita Bay. We had a Rhine River cruise booked for June through our travel agent in Michigan. In late April, as we were packing to head north, Linda pulled our passports and discovered hers had expired two months ago. We panicked — the cruise was fully paid, non-refundable, and our travel agent said there was no way to get a passport in time through standard channels. Fast Passport Center processed Linda's renewal in 5 business days. We shipped her documents from the UPS Store on U.S. 41 in Bonita Springs before we left for Michigan, and her new passport was waiting for us when we arrived. We made our cruise with a week to spare. Absolutely exceptional service.",
    service: "Passport Renewal",
  },
  {
    name: "James K.",
    location: "Bonita Springs, FL — Pelican Landing",
    rating: 5,
    text: "I am an avid offshore fisherman with a boat docked near Bonita Springs. We had a Bimini fishing tournament planned with four buddies — departure from Fort Myers Beach, weather window looked perfect for the weekend. On Tuesday, three days before we planned to leave, I pulled my passport and realized it had expired in January. I had not used it since last year's Bahamas trip and completely lost track. I called Fast Passport Center in desperation. They understood the boating urgency immediately — it is not like a flight you can reschedule. They guided me through the exact documents, I overnighted everything from the FedEx in Fort Myers, and I had my new passport by Friday morning. We made our Saturday departure to Bimini and placed third in the tournament. Cannot recommend them highly enough to any boater in Southwest Florida.",
    service: "Emergency Passport Renewal",
  },
  {
    name: "Margaret T.",
    location: "Bonita Springs, FL — Near Barefoot Beach",
    rating: 5,
    text: "I am a retired teacher from Toronto who winters in Bonita Springs every year. My daughter in Vancouver had her first baby in March, and I wanted to be there as soon as possible. I booked a flight from RSW to Vancouver with a connection in Toronto, and the night before I was supposed to leave, I discovered my Canadian passport had expired. I also hold U.S. citizenship and a U.S. passport, but my Canadian passport was what I always used to visit family. Fast Passport Center helped me understand that my U.S. passport would work for entry to Canada, which saved my trip immediately. But they also helped me start my Canadian renewal so I would not face this again. The team was patient, knowledgeable, and genuinely caring. I have told every Canadian snowbird I know in Bonita Springs about them.",
    service: "Passport Consultation & Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function BonitaSpringsTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Bonita Springs Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Bonita Springs residents who trusted Fast Passport Center with their expedited passports — from Bonita Bay to Pelican Landing to Barefoot Beach.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}